import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Entity } from 'src/app/shared/entity-search/entity-search.service';
import { EntityType } from 'src/app/core/settings/settings.service';
import { EntitySearchService } from 'src/app/shared/entity-search/entity-search.service';

@Component({
  selector: 'bulk-entity-input',
  templateUrl: './bulk-entity-input.component.html',
  styleUrls: ['./bulk-entity-input.component.scss']
})
export class BulkEntityInputComponent {
  private guidRegex = /^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/;
  private serialRegex = /^[a-zA-Z]{2}\d{8}$/;

  @Input() title: string | undefined = '';
  @Input() placeholder: string | undefined = '';
  @Input() entities: Entity[] | undefined;
  @Input() entityType: EntityType | undefined;
  @Output() bulkAdd: EventEmitter<Entity[]> = new EventEmitter();
  
  inputText: string = '';
  error: string = '';
  get deviceDisplay(): string {
    return this.entities.map(e => e.id).join(', ');
  }

  loading: boolean = false;

  get isDevice(): boolean {
    return this.entityType === EntityType.device;
  }

  constructor(private entitySearchService: EntitySearchService) { }

  async add() {
    this.error = '';
    this.loading = true;

    try {
      await this.addEntities();
    } catch (e) {
      this.error = `An error occurred while adding entities: ${e.message || e}`;
    } finally {
      this.loading = false;
    }
  }

  private async addEntities() {
    let errorIds = [];
    let errors = [];
    let entityIds = this.inputText.split(/[\s,]+/);

    entityIds = this.filterIds(entityIds, errors, errorIds);

    let entities = await this.entitySearchService.getEntitiesById(this.entityType, entityIds);
    
    this.errorOnNotFound(entityIds, entities, errors, errorIds);

    if (errors.length > 0) {
      this.error = errors.join('\n');
    }

    this.inputText = errorIds.join(', ');
    this.bulkAdd.emit(entities);
  }

  filterIds(ids: string[], errors: string[], errorIds: string[]): string[] {
    ids = [...new Set(ids.map(g => g.trim()))].filter(g => g.trim().length > 0).filter(g => g.trim().length > 0);

    let duplicates = ids.filter(g => this.entities.some(e => e.id == g)).map(g => `${g} is duplicated.`);
    errors.push(...duplicates);

    ids = ids.filter(g => !this.entities.some(e => e.id == g));

    let regex = this.entityType === EntityType.device ? this.serialRegex : this.guidRegex;

    let invalidIds = ids.filter(g => !regex.test(g));
    let idType = this.entityType === EntityType.device ? 'serial number' : 'GUID';
    if (invalidIds.length > 0) {
      errorIds.push(...invalidIds);
      errors.push(...invalidIds.map(g => `${g} is not a valid ${idType}.`));
    }

    return ids.filter(id => regex.test(id));
  }

  errorOnNotFound(ids: string[], entities: Entity[], errors: string[], errorIds: string[]) {
    let notFoundEntities = ids.filter(g => !entities.some(e => e.id === g));
    if (notFoundEntities.length > 0) {
      errorIds.push(...notFoundEntities);
      errors.push(...notFoundEntities.map(g => `Could not find ${this.entityType.toLowerCase()} ${g}.`));
    }
  }
}
